import { useState } from "react";
import SelectInput from "./SelectInput";
import { FiBook } from "react-icons/fi";

type SubjectOption = {
  label: string;
  value: string;
};

type QuestionProps = {
  onSubjectChange: (subjectId: string) => void;
  subjectOptions: { subjectName: string; subjectCode: string }[];
  selectedSubject: string | null;
};

const Question = ({ onSubjectChange, subjectOptions, selectedSubject }: QuestionProps) => {
  const [error, setError] = useState(false);

  const handleChange = (value: string) => {
    if (value.trim()) {
      setError(false);
      onSubjectChange(value);
    } else {
      setError(true);
    }
  };

  const formattedOptions: SubjectOption[] = subjectOptions.map((item) => ({
    label: item.subjectName,
    value: item.subjectCode,
  }));

  return (
    <div className="w-xs">
      <SelectInput
      name="subject"
      label="Subject Name"
      value={selectedSubject || ""}
      onChange={handleChange}
      options={formattedOptions}
      placeholder="Select..."
      required
      error={error}
      errorMessage="Please select a subject"
      icon={FiBook}
    />
    </div>
  );
};

export default Question;
